module.exports = __webpack_public_path__ + "img/W-G22.a3448d21.jpg";